import {ConversationNoteService} from '../../libs/ui/src/index';

import {client} from '../apiService';
const _ConversationNoteService = new ConversationNoteService({client});
export {_ConversationNoteService as ConversationNoteService};
